import React, { useState, useEffect, useContext } from "react";
import { useParams, NavLink, Link } from "react-router-dom";
import { AppLoad } from "../../../core/AppLoad";
import { AppConfig, AppStateContext, EloginStatus } from "../../../app-state";
import { Spinner } from "../../../core/Spinner";
import { getEventUrl } from "../../common/event/EventHelper";
import { Icon } from "../../../core/Icon";
import { SubmitButton } from "../../../core/SubmitButton";
import { HowToText } from "../../event-master/articles/HowToText";
export const EnrollProcess = () => {
    const { state, dispatch } = useContext(AppStateContext);
    // const [submitErrors, setSubmitErrors] = useState([]);
    const [loadState, setLoadState] = useState('idle'); //idle | loadingEdit | submitting
    const [eventData, setEventData] = useState({});
    const { urlEventId } = useParams();
    const TryEnroll = () => {
        if (loadState == 'submitting')
            return;
        // setSubmitErrors([]);
        setLoadState('submitting');
        AppLoad(AppConfig.APIUrl + 'secured/event/try-enroll', { eventId: urlEventId }).then((Response) => {
            if (Response.status == 'error') {
                if (Response.message == 'existing_enrollment')
                    alert('K této aukci jste již zapsaní');
                setLoadState('idle');
            }
            else if (Response.status == 'ok') {
                setLoadState('saved');
            }
        });
    };
    const loadEditData = () => {
        setLoadState('loadingEdit');
        AppLoad(AppConfig.APIUrl + 'public/events/enroll-meta', { eventId: urlEventId }).then((Response) => {
            if (Response.status == 'error') {
                // setSubmitErrors(Response.errors)
            }
            else if (Response.status == 'ok') {
                setEventData(Response.data);
                setLoadState('idle');
            }
        });
    };
    useEffect(() => {
        if (urlEventId)
            loadEditData();
    }, [urlEventId]);
    if (loadState == 'loadingEdit')
        return React.createElement(Spinner, { large: true });
    return (React.createElement(React.Fragment, null,
        urlEventId && React.createElement("div", { className: "navbar" },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "navbar-inner" },
                    React.createElement(NavLink, { to: getEventUrl(eventData), className: "back-link" },
                        React.createElement("span", { className: "icon", "aria-hidden": true }),
                        React.createElement("span", { className: "text" }, "Zp\u011Bt detail aukce"))))),
        state.loginState == EloginStatus.Logged ?
            React.createElement(React.Fragment, null, loadState == 'saved' ?
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "container text-center pt-48" },
                        React.createElement(Icon, { c: ['tick-circle', 64, 64, 'success-icon'] }),
                        React.createElement("h1", { className: "mt-8 mb-0" }, "P\u0159ihl\u00E1\u0161en\u00ED prob\u011Bhlo \u00FAsp\u011B\u0161n\u011B"),
                        React.createElement("p", null, "Ujist\u011Bte se pros\u00EDm, \u017Ee jste p\u0159ed zah\u00E1jen\u00EDm aukce splnili n\u00E1sleduj\u00EDc\u00ED podm\u00EDnky pro \u00FA\u010Dast:")),
                    React.createElement(HowToText, null),
                    React.createElement("div", { className: "container text-center  pb-48" },
                        React.createElement(NavLink, { to: "/cs/seznam/moje-aukce", className: "primary-button" },
                            React.createElement("span", { className: "text" }, "Zobrazit moje aukce"))))
                :
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "process-master-form text-center" },
                            React.createElement("h1", { className: "mb-8" }, "P\u0159ihl\u00E1\u0161en\u00ED do aukce"),
                            React.createElement("p", null, "Po p\u0159ihl\u00E1\u0161en\u00ED k aukci je t\u0159eba splnit n\u00E1sleduj\u00EDc\u00ED podm\u00EDnky:"),
                            React.createElement("p", { className: "mb-8" },
                                React.createElement("b", null, "Slo\u017Een\u00ED auk\u010Dn\u00ED jistoty")),
                            React.createElement("p", { className: "mb-8" },
                                React.createElement("b", null, "Doru\u010Dit podepsanou smlouvu o \u00FA\u010Dasti v elektronick\u00E9 aukci")),
                            React.createElement("p", { className: "mb-32" },
                                React.createElement("b", null, "Potvrzen\u00ED \u00FA\u010Dasti administr\u00E1torem")),
                            React.createElement(SubmitButton, { loadState: loadState, onClick: () => TryEnroll(), label: "P\u0159ihl\u00E1sit se do aukce" }))))
            :
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "process-master-form" },
                        React.createElement("div", null,
                            React.createElement("h1", { className: "mb-8" }, "P\u0159ihl\u00E1\u0161en\u00ED do aukce"),
                            "Je vy\u017Eadov\u00E1no p\u0159ihl\u00E1\u0161en\u00ED. Pokud u\u017E m\u00E1te \u00FA\u010Det, ",
                            React.createElement(Link, { className: "hyperlink", to: "/cs/proces/prihlaseni-uzivatele" }, "p\u0159ihlaste se"),
                            ".",
                            React.createElement("span", null, "Nebo se "),
                            React.createElement(Link, { className: "hyperlink", to: "/cs/proces/registrace" }, "zaregistrujte"),
                            " a opakujte p\u0159ihl\u00E1\u0161en\u00ED do aukce.")))));
};
